// src/stable/useActiveEffect.ts
import { useEffect } from "react";
import { useActivity } from "../__internal__/activity/useActivity.mjs";
import { noop } from "../__internal__/utils/index.mjs";
var useActiveEffect = (effect) => {
  const { isActive } = useActivity();
  useEffect(() => {
    if (isActive) {
      return effect();
    }
    return noop;
  }, [isActive]);
};
export {
  useActiveEffect
};
